<script setup lang="ts">
import SectionCustomerStatuses from './SectionCustomerStatuses.vue'

defineOptions({
  name: 'CustomerStatusesAndSourcesPage',
})
</script>

<template>
  <SectionCustomerStatuses />
</template>
